import { Component, inject } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

import { ThemeService } from '../theme.service'

@Component({
    templateUrl: './appearance-settings.component.html',
    standalone: true,
})
export class AppearanceSettingsComponent {
    private activeModal = inject(NgbActiveModal)
    theme = inject(ThemeService)

    close(): void {
        this.activeModal.close()
    }
}
